import { render, staticRenderFns } from "./MediakitProductsTable.vue?vue&type=template&id=6c8f3e91&scoped=true&"
import script from "./MediakitProductsTable.vue?vue&type=script&lang=js&"
export * from "./MediakitProductsTable.vue?vue&type=script&lang=js&"
import style0 from "./MediakitProductsTable.vue?vue&type=style&index=0&id=6c8f3e91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f3e91",
  null
  
)

export default component.exports